const leadMatrix8Combined = {
    name: "leadmatrix8combined",
    iconName: "icon-default",
    title: "Lead Position",
    elementsJSON:
        [
            { type: "leadmatrix4left", name: "left", title: {"default":"Left","de":"Left"} },
            { type: "leadmatrix4right", name: "right", title: {"default":"Right","de":"Right"}, startWithNewLine: false }
        ],
    onAfterRender(question, htmlElement) {
        htmlElement.className += ' leads8';
    }
}

export default leadMatrix8Combined;